import { BRAND_CODE } from "@/config/common";
import { MarketConfiguration } from "@/config/markets/const";
import type { CustomProduct } from "@apptus/esales-api";

export default function getVatRateFromProduct(
  product: CustomProduct,
  marketConfig: MarketConfiguration,
) {
  if (!product.typedCustom?.numbers) return undefined;

  const identifier = `${BRAND_CODE}_${marketConfig.code}`;

  return product.typedCustom.numbers[`vat_${identifier}`];
}
